import { useState } from "react";
import ConfirmModal from "../components/modals/dialog";

/**
 * UseConfirmProps<T> - Define que onConfirm recebe obrigatoriamente um valor do tipo T.
 */
interface UseConfirmProps<T> {
  onConfirm: (arg: T) => void;
}

/**
 * ConfirmState<T> - Armazena título, mensagem e o valor (arg) a ser passado para onConfirm.
 */
interface ConfirmState<T> {
  title: string;
  message: string;
  arg: T;
}

/**
 * Hook genérico: useConfirm<T>
 * - handleShow exibe a modal recebendo (title, message, arg).
 * - Ao confirmar, chamamos onConfirm(arg).
 */
function useConfirm<T>({ onConfirm }: UseConfirmProps<T>) {
  const [show, setShow] = useState(false);
  const [confirmState, setConfirmState] = useState<ConfirmState<T> | null>(
    null
  );

  function handleShow(title: string, message: string, arg: T) {
    setConfirmState({ title, message, arg });
    setShow(true);
  }

  function handleHide() {
    setShow(false);
    setConfirmState(null);
  }

  function handleConfirm() {
    if (confirmState) {
      onConfirm(confirmState.arg);
    }
    handleHide();
  }

  const ConfirmModalComponent = (
    <ConfirmModal
      show={show}
      onHide={handleHide}
      onConfirm={handleConfirm}
      title={confirmState?.title ?? ""}
      message={confirmState?.message ?? ""}
    />
  );

  return {
    handleShow, // (title: string, message: string, arg: T) => void
    ConfirmModalComponent, // elemento <ConfirmModal />
  };
}

export default useConfirm;
